import { MediaType } from '@confluence/graphql/entry-points/MediaType.ts';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation.ts';

import type {
	EditorStopHeartbeatMutation as EditorStopHeartbeatMutationData,
	EditorStopHeartbeatMutationVariables,
} from './__types__/EditorStopHeartbeatMutation.ts';

export const useExperimentalEditorStopHeartbeatMutation = ({
	variables,
}: {
	variables: EditorStopHeartbeatMutationVariables;
}) => {
	return useExperimentalMutation<
		EditorStopHeartbeatMutationData,
		EditorStopHeartbeatMutationVariables,
		boolean
	>({
		url: '/wiki/api/v2/editor/heartbeat/stop',
		method: 'POST',
		variables,
		headers: {
			Accept: MediaType.JSON,
			'Content-Type': MediaType.JSON,
		},
		body: ({ contentId, contentType, heartbeatUserType }) =>
			JSON.stringify({
				dataType: 'json',
				contentId,
				draftType: contentType ?? '',
				heartbeatUserType,
			}),
		parseResponseOnError: () => {
			return false;
		},
		parseResult: (response) => {
			return {
				experimentalEditorStopHeartbeat: Boolean(response),
			};
		},
	});
};
